// Partner/Integration icons - shared constant to avoid duplication
import BoldTrailIcon from "src/assets/icons/integrations/boldtrail.svg";
import FollowUpBossIcon from "src/assets/icons/integrations/follow-up-boss.svg";
import HighLevelIcon from "src/assets/icons/integrations/highlevel.svg";
import IListIcon from "src/assets/icons/integrations/ilist.png";
import LoftyIcon from "src/assets/icons/integrations/lofty.svg";
import MarketGeniusIcon from "src/assets/icons/integrations/market-genius.png";
import MojoIcon from "src/assets/icons/integrations/mojo.svg";
import TopProducerIcon from "src/assets/icons/integrations/top-producer.png";
import WiseAgentIcon from "src/assets/icons/integrations/wise-agent.png";

// Map partner ID to icon
export const partnerIcons: Record<string, string> = {
  ilist: IListIcon,
  marketgenius: MarketGeniusIcon,
  mojo: MojoIcon,
  topproducer: TopProducerIcon,
  wiseagent: WiseAgentIcon,
  "rollout-boldtrail": BoldTrailIcon,
  "rollout-followupboss": FollowUpBossIcon,
  "rollout-highlevel": HighLevelIcon,
  "rollout-lofty": LoftyIcon,
};

// Map partner ID to Rollout appKey (the appKey format differs from internal ID)
export const rolloutAppKeys: Record<string, string> = {
  "rollout-boldtrail": "boldtrail",
  "rollout-followupboss": "follow-up-boss",
  "rollout-highlevel": "highlevel",
  "rollout-lofty": "lofty",
};
